// b11 Sharlar — variant that renders the standalone HTML at
// /templates/sharlar.html (kids' circus / carnival birthday invitation:
// aged parchment + burgundy + gold, Abril Fatface + Playfair Display +
// Cormorant Garamond; layered arch hero with floating balloons, bunting
// flags and stars, scroll-reveal sections, live countdown). Inside a
// full-bleed iframe.
//
// Flat .html — NOT a nested index.html. Go's http.FileServer
// 301-redirects any request ending in /index.html to the bare
// directory, which then falls through to the SPA and renders the wrong
// template. Every static template in this repo is a flat file.
//
// The HTML's customizer accepts DD.MM.YYYY directly — names/date/time/
// venue/address pass through raw on the query string. For birthdays
// `names` is treated as the single child name (first segment only).
// Optional ?age= populates the "9 — turns nine —" line.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/sharlar.html";

export function SharlarStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.mapUrl) params.set("map_url", t.mapUrl);
  // ?age populates the "turns nine" line. Surfaced through editor as
  // an extraField on the b11 row in data.ts.
  const age = typeof t.custom?.age === "string" ? t.custom.age.trim() :
              typeof t.custom?.age === "number" ? String(t.custom.age) : "";
  if (age) params.set("age", age);
  if (ctx.slug) params.set("slug", ctx.slug);
  // ?audio=/music/<id>.mp3 — owner-picked soundtrack from the
  // curated MusicSelector library. Empty/unset = silent card.
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Sharlar"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#e7d3a4",
      }}
    />
  );
}
